import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, take } from 'rxjs';

import { UserFacade } from '../store/user/user.facade';
import { UtmPreservationService } from '../services/utm-preservation.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private userFacade = inject(UserFacade);
  private router = inject(Router);
  private utmPreservationService = inject(UtmPreservationService);


  canActivate(): Observable<boolean> {
    return this.userFacade.getIsAuthenticated().pipe(
      take(1),
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        } else {
          const queryParams = this.utmPreservationService.addPreservedUtmToQueryParams({});
          this.router.navigate(['/login'], { queryParams });
          return false;
        }
      })
    );
  }
}
